import React, { Component } from "react";
import { Row, Col, Card, Container } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql, withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import CardLessDataTable from "../datatables/CardLessDataTableWithSearch";
import StudentModal from './addStudentsModal';
import EditDetailsModal from './editDetailsModal';
import { PageCardShimmer } from '../preloader/PageCardShimmer';
import CheckboxDropdown from '../common/CheckboxDropdown';
import {
    getAuthorizedBranchIds,
    getAuthorizedClassIds,
    getAuthorizedSectionIds,
    filterByAuthorizedIds
} from "../../utils/authHelper";
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";
import './_educationManagementStudents.scss';
import { canView } from "../../../utils/modulePermissions";
import {
    attachModuleGuard,
    AccessDeniedModal,
    AccessDeniedCard,
} from "../../../utils/moduleGuard";
// Reuse the MIS module's Excel helper (xlsx + file-saver). PDF uses the browser print
// window, exactly like the Finance module's "Print / PDF" button.
import { exportExcel } from "../managementMISReports/misExport";

// /settings/non-academic-students → "non_academic_students" (see MODULE_ROUTES in
// moduleAccessGuard).
// module_key ONLY, never module_name: the sidebar group name is shared by sibling
// modules, and can() grants an action when ANY matched row allows it — matching the
// group would let another module's grant leak in.
const NON_ACADEMIC_STUDENTS_MODULE = ["non_academic_students"];
// The grant row is keyed by sub_module_name "non_academic_students". Scope every check
// to it so that if the backend ever returns another row under the same module_key, its
// grant can't leak in — can() grants an action when ANY matched row allows it.
const NON_ACADEMIC_STUDENTS_SUB = "non_academic_students";

// ── GraphQL ───────────────────────────────────────────────────────────────────

const GET_STUDENT_DETAILS = gql`
query($institution_id:Int!,$branch_id:String,$include_inactive:Boolean){
    getNewEducationalStudents:getCombinedAcademicAndNonAcademicStudents(institution_id: $institution_id,branch_id:$branch_id,include_inactive:$include_inactive) {
    student_user_id
    edu_student_id
    studentEnrollmentDropoutId
    estatus
    roll_no
    contact_no
    admission_no
    student_name
    class_id
    class_name
    exam_id
    exam_name
    branch_id
    branch_name
    section_id
    section_name
    parent_name
    parent_mobile
    father_name
    father_phone
    mother_name
    mother_phone
    parent_password
    student_user_id
    student_mobile
    profile_image
    profile_image_base
    academic_year_id
    dob
    gender
    adhar_no
    pen_no
    admitted_date
    stream_id
    stream_name
    stream_name
    student_exam_details {
      student_user_exam_id
      student_user_id
      exam_ids
    }
    }
}
`;

const GET_CLASSES = gql`
    query($id: Int) {
        getExamClasses(id: $id) {
            id
            class
        }
    }
`;

const GET_STREAMS = gql`
    query {
        getStreams {
            id
            stream
            classes
        }
    }
`;

const GET_BRANCHES = gql`
    query getBranches($institution_id: Int!) {
        getBranches(institution_id: $institution_id) {
            id
            branch_name
            sections {
                id
                class_id
                stream_id
                section_name
            }
        }
    }
`;

// Institute name / address / logo for report headers. The institute_logo cookie is only set
// in the student app (not staff login), so the PDF logo must come from this query.
const GET_ORGANISATION_PROFILE = gql`
    query($institution_id: Int!) {
        getOrganisationProfile(institution_id: $institution_id) {
            id
            organisation_name
            logo
            complete_address
        }
    }
`;

const EDIT_PARENT = gql`
  mutation($params: EditParent) {
    editParent(params: $params)
  }
`;

const EDIT_STUDENT = gql`
  mutation($params: EditStudentInput) {
    editStudent(params: $params)
  }
`;

const EDIT_EDU_STUDENT = gql`
  mutation($params: EditEduStudent) {
    editEduStudent(params: $params)
  }
`;

const ADD_PROFILE_IMAGE = gql`
  mutation($profile_image: String, $profile_image_base: String, $user_id: Int, $institute_id: Int, $type: String,$edu_student_id: ID, $student_user_id: Int) {
    addProfileImage(profile_image: $profile_image, profile_image_base: $profile_image_base, user_id: $user_id, institute_id: $institute_id, type: $type,edu_student_id: $edu_student_id, student_user_id: $student_user_id)
  }
`;

const DELETE_STUDENT = gql`
    mutation($edu_student_id: ID!, $student_user_id: Int) {
       deleteEduStudentMutation(edu_student_id: $edu_student_id, student_user_id: $student_user_id)
    }
`;

// Toggle enrollment status: status = 1 -> Enrolled (rejoin), 2 -> Dropout.
const SET_ENROLLMENT_STATUS = gql`
    mutation($edu_student_id: ID!, $student_user_id: Int, $status: Int!) {
        setEduStudentEnrollmentStatus(edu_student_id: $edu_student_id, student_user_id: $student_user_id, status: $status)
    }
`;

// ── Component ─────────────────────────────────────────────────────────────────
class EducationManagementStudentsSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branches: [],
            getClasses: [],
            streams: [],
            branchSearch: [],
            classSearch: [],
            streamSearch: [],
            sectionSearch: [],
            enrollmentSearch: [0, 1, 2],
            modalShow: false,
            editModal: false,
            rowData: [],
            parentName: "",
            parentNameError: "",
            parentMobile: "",
            parentMobileError: "",
            parentPassword: "",
            parentPasswordError: "",
            confirmParentPassword: "",
            confirmPasswordError: "",
            student_user_id: 0,
            edu_student_id: 0,
            submitError: "",
            loadingSpinner: 0,
            currentStep: 1,
            isSubmitting: false,
            deletingStudentId: null,
            // edu_student_ids removed via Delete — filtered out of the list immediately so
            // the row disappears on the frontend even before the refetch resolves (the DB
            // row is soft-deleted to estatus=0).
            deletedEduStudentIds: [],
            togglingStudentId: null,
            // Optimistic status overrides: edu_student_id -> estatus (2 = Dropout, 1 = Enrolled).
            // Applied to the row immediately on a successful toggle so the UI updates without
            // waiting for (or blanking the page on) a refetch. Cleared once the refetch confirms.
            statusOverrides: {},
            accessDeniedShow: false,
            orgProfile: {},   // organisation_name / logo / complete_address for the PDF header
        };

        this.guard = attachModuleGuard(this, NON_ACADEMIC_STUDENTS_MODULE, NON_ACADEMIC_STUDENTS_SUB);
    }

    componentDidMount() {
        // is_view === 0 → don't fetch anything. These three are imperative
        // client.query() calls, so the `skip` on the graphql HOCs doesn't cover them —
        // they have to be bailed out of here or the module's data still loads.
        if (!this.guard.canView()) return;

        this.getBranches();
        this.getClasses();
        this.getStreams();
        this.getOrgProfile();
        // Branch comes from the header (NavbarOne) — re-scope when it changes.
        this.offBranchScope = onBranchScopeChange(() => this.getBranches());
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    // Institute header for the PDF (staff login has no institute_logo cookie).
    getOrgProfile = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_ORGANISATION_PROFILE,
                variables: { institution_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "cache-first",
            });
            this.setState({ orgProfile: (result.data && result.data.getOrganisationProfile) || {} });
        } catch (e) { /* header is optional — PDF still works without it */ }
    };

    getBranches = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_BRANCHES,
                variables: { institution_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            // The header's branch selection (NavbarOne) IS this page's branch filter.
            let branches = scopeBranches(result.data.getBranches || []);
            const allowedClasses = getAuthorizedClassIds();
            const allowedSections = getAuthorizedSectionIds();
            if (allowedClasses.length || allowedSections.length) {
                branches = branches.map(b => ({
                    ...b,
                    sections: filterByAuthorizedIds(
                        filterByAuthorizedIds(b.sections || [], allowedSections, "id"),
                        allowedClasses,
                        "class_id"
                    ),
                }));
            }
            const allBranchIds = branches.map(b => b.id);
            const allClassIds = Array.from(new Set(branches.flatMap(b => b.sections || []).map(s => s.class_id)));
            const allStreamIds = Array.from(new Set(branches.flatMap(b => b.sections || []).map(s => s.stream_id).filter(Boolean)));
            const allSectionIds = branches.flatMap(b => b.sections || []).map(s => s.id);
            this.setState({ branches, branchSearch: allBranchIds, classSearch: allClassIds, streamSearch: allStreamIds, sectionSearch: allSectionIds });
        } catch {
            // ignore
        }
    };

    getClasses = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_CLASSES,
                variables: { id: 1 },
                fetchPolicy: "network-only",
            });
            const classes = filterByAuthorizedIds(
                result.data.getExamClasses || [],
                getAuthorizedClassIds(),
                "id"
            );
            this.setState({ getClasses: classes });
        } catch {
            // ignore
        }
    };

    getStreams = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_STREAMS,
                fetchPolicy: "network-only",
            });
            this.setState({ streams: result.data.getStreams || [] });
        } catch {
            // ignore
        }
    };

    tableData(students) {
        // The student record already carries branch/class/section/exam names, so these
        // are read directly (previously fell back to the removed `globals` query).
        return students.map(s => {
            return {
                // Unique, non-null key for react-bootstrap-table's keyField. student_user_id
                // is null for academic-only students (no online login), so keying on it made
                // many rows collide on id=null — the table then reused DOM rows across filter
                // changes and showed stale rows (Deleted lingering under Active, etc.).
                id: s.edu_student_id != null ? `edu-${s.edu_student_id}` : `su-${s.student_user_id}`,
                student_name: s.student_name,
                contact_no: s.contact_no,
                exam_name: s.exam_name || "",
                exam_id: s.exam_id || "",
                branch_name: s.branch_name || "",
                class_name: s.class_name || "",
                section_name: s.section_name || "",
                branch: s.branch_id || "",
                class: s.class_id || "",
                stream: s.stream_id || "",
                // Stream only applies to Class 11 (id 1) & Class 12 (id 2).
                stream_name: [1, 2].includes(Number(s.class_id)) ? (s.stream_name || "") : "",
                section: s.section_id || "",
                parent_name: s.parent_name ?? "-",
                parent_mobile: s.parent_mobile ?? "-",
                father_name: s.father_name ?? "-",
                father_phone: s.father_phone ?? "-",
                mother_name: s.mother_name ?? "-",
                mother_phone: s.mother_phone ?? "-",
                parent_password: s.parent_password,
                student_id: s.edu_student_id,
                edu_student_id: s.edu_student_id,
                student_user_id: s.student_user_id,
                roll_no: s.roll_no,
                admission_no: s.admission_no,
                is_academic_exist: s.is_academic_exist,
                is_non_academic_exist: s.is_non_academic_exist,
                profile_image_base: s.profile_image_base,
                profile_image: s.profile_image,
                academic_year_id: s.academic_year_id,
                dob: s.dob || "",
                gender: s.gender || "",
                adhar_no: s.adhar_no || "",
                pen_no: s.pen_no || "",
                admitted_date: s.admitted_date || "",
                studentEnrollmentDropoutId: s.studentEnrollmentDropoutId,
                estatus: s.estatus,
            };
        })
        // Latest-added students first (highest edu_student_id at the top).
        .sort((a, b) => (parseInt(b.edu_student_id) || 0) - (parseInt(a.edu_student_id) || 0))
        // Stamp a stable serial number AFTER sorting. The table's rowIndex is page-relative
        // (restarts at 0 on each page), so read this baked-in `sno` in the "#" column instead
        // to keep the numbering continuous across pagination.
        .map((r, i) => ({ ...r, sno: i + 1 }));
    }

    articlecolumns = [
        { dataField: "sno", text: "#", formatter: (cell, row) => row.sno },
        { dataField: "student_name", text: "Student Name", sort: true, formatter: this.studentNameFunc.bind(this) },
        { dataField: "admission_no", text: "Admission No", sort: true, formatter: (cell) => cell || "-" },
        { dataField: "roll_no", text: "Roll No", sort: true, formatter: (cell) => cell || "-" },
        // { dataField: "father_name", text: "Father Name", sort: true, formatter: (cell) => cell || "-" },
        { dataField: "father_name", text: "Parent Name", sort: true, formatter: (cell, row) => cell || row.parent_name || "-" },
        { dataField: "branch_name", text: "Branch", sort: true, formatter: (cell) => cell || "-" },
        { dataField: "class_name", text: "Class", sort: true, formatter: (cell) => cell || "-" },
        // Stream applies only to Class 11 (id 1) & Class 12 (id 2); other classes show "-".
        { dataField: "stream_name", text: "Stream", sort: true, formatter: (cell, row) => ([1, 2].includes(Number(row.class)) ? (cell || "-") : "-") },
        { dataField: "section_name", text: "Section", sort: true, formatter: (cell) => cell || "-" },
        {
            dataField: "studentEnrollmentDropoutId", text: "Status", sort: true, formatter: (cell, row) => {
                // Deleted (estatus 0) wins over enrollment status. studentEnrollmentDropoutId
                // === 0 is an active student (no dropout record), NOT deleted.
                const est = row && row.estatus !== undefined && row.estatus !== null ? Number(row.estatus) : null;
                if (est === 0) return <span style={{ color: "#6B7280", fontWeight: "bold" }}>Deleted</span>;
                const val = cell !== undefined && cell !== null ? Number(cell) : 1;
                if (val === 2) return <span style={{ color: "#EF4444", fontWeight: "bold" }}>Dropout</span>;
                return <span style={{ color: "#10B981", fontWeight: "bold" }}>Active</span>;
            }
        },
        { dataField: "", text: "Actions", sort: false, formatter: this.actionsFunc.bind(this) },
    ];

    studentNameFunc(cell, row, rowIndex) {
        const img = row.profile_image || row.profile_image_base;
        return (
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 32, height: 32, borderRadius: "50%", overflow: "hidden", background: "#eff6ff", border: "1px solid #dbeafe", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    {img ? (
                        <img src={img} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    ) : (
                        <i className="fas fa-user" style={{ color: "#93c5fd", fontSize: 13 }} />
                    )}
                </div>
                <Link
                    className="edu-student-link text-primary font-weight-bold"
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    to={{
                        // pathname: "/home/student-profile-analytics",
                        pathname:"/student-profile-1/overview",
                        state: { student: row }
                    }}
                >
                    {row.student_name}
                </Link>
            </div>
        );
    }

    actionsFunc(cell, row) {
        const isDeleting = !!this.state.deletingStudentId && String(this.state.deletingStudentId) === String(row.edu_student_id);
        const isToggling = !!this.state.togglingStudentId && String(this.state.togglingStudentId) === String(row.edu_student_id);
        const isEnrolled = Number(row.studentEnrollmentDropoutId ?? 1) !== 2;
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: 12 }}>
                <button
                    className="edu-edit-btn"
                    title="Edit Details"
                    onClick={() => this.EditModal(row)}
                >
                    <i className="far fa-edit"></i>
                </button>
                <button
                    title={isEnrolled ? "Mark as Dropout" : "Rejoin"}
                    disabled={isToggling}
                    onClick={() => !isToggling && this.handleToggleEnrollment(row)}
                    style={{
                        background: "none", border: "none", cursor: isToggling ? "default" : "pointer",
                        color: isEnrolled ? "#EF4444" : "#10B981", fontSize: 15, padding: 0,
                    }}
                >
                    <i className={isToggling ? "fas fa-spinner fa-spin" : (isEnrolled ? "fas fa-user-slash" : "fas fa-user-check")}></i>
                </button>
                <button
                    className="edu-delete-btn"
                    title="Delete"
                    disabled={isDeleting}
                    onClick={() => !isDeleting && this.handleDeleteStudent(row)}
                    // While deleting, override the .edu-delete-btn:disabled opacity fade so the
                    // spinner shows crisp/full-strength — same as the dropout button's spinner.
                    style={isDeleting ? { opacity: 1, cursor: "default" } : undefined}
                >
                    <i className={isDeleting ? "fas fa-spinner fa-spin" : "far fa-trash-alt"}></i>
                </button>
            </div>
        );
    }

    // ---- Excel / PDF export of the currently-filtered student list ----
    // Columns mirror the on-screen table plus the contact numbers (useful in an export).
    exportColumns = [
        { key: "sno", label: "S.No" },
        { key: "student_name", label: "Student Name" },
        { key: "admission_no", label: "Admission No" },
        { key: "roll_no", label: "Roll No" },
        { key: "adhar_no", label: "Aadhaar No" },
        { key: "pen_no", label: "PEN No" },
        { key: "dob", label: "Date of Birth" },
        { key: "admitted_date", label: "Admitted Date" },
        { key: "contact_no", label: "Student Mobile" },
        { key: "parent_name_disp", label: "Parent Name" },
        { key: "parent_mobile_disp", label: "Parent Mobile" },
        { key: "mother_name", label: "Mother Name" },
        { key: "branch_name", label: "Branch" },
        { key: "class_name", label: "Class" },
        { key: "stream_name", label: "Stream" },
        { key: "section_name", label: "Section" },
        { key: "status_disp", label: "Status" },
    ];

    // Build [header, ...rows] from the filtered rows captured in render (this._exportRows).
    buildExportMatrix() {
        const rows = this._exportRows || [];
        const cols = this.exportColumns;
        const header = cols.map((c) => c.label);
        // Dates shown as DD/MM/YYYY. Handles YYYY-MM-DD / ISO strings (dob) AND unix timestamps —
        // admitted_date is a `timestamp` column that arrives as unix seconds (e.g. 1784118371).
        const fmtDMY = (v) => {
            if (v == null || v === "" || v === "-") return "-";
            const s = String(v).trim();
            // Plain YYYY-MM-DD or ISO -> take the date part directly (no timezone shift).
            const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
            if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
            let d = null;
            if (/^\d{10}$/.test(s)) d = new Date(Number(s) * 1000);   // unix seconds
            else if (/^\d{13}$/.test(s)) d = new Date(Number(s));     // unix milliseconds
            else { const p = new Date(s); if (!isNaN(p.getTime())) d = p; }
            if (d && !isNaN(d.getTime())) {
                return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
            }
            return s;
        };
        const val = (r, key, i) => {
            switch (key) {
                case "sno": return i + 1;
                case "parent_name_disp":
                    return (r.father_name && r.father_name !== "-") ? r.father_name : (r.parent_name && r.parent_name !== "-" ? r.parent_name : "-");
                case "parent_mobile_disp":
                    return (r.parent_mobile && r.parent_mobile !== "-") ? r.parent_mobile : (r.father_phone && r.father_phone !== "-" ? r.father_phone : "-");
                case "status_disp": {
                    const est = r.estatus !== undefined && r.estatus !== null ? Number(r.estatus) : null;
                    if (est === 0) return "Deleted";
                    return Number(r.studentEnrollmentDropoutId ?? 1) === 2 ? "Dropout" : "Active";
                }
                case "stream_name":
                    return [1, 2].includes(Number(r.class)) ? (r.stream_name || "-") : "-";
                case "dob": return fmtDMY(r.dob);
                case "admitted_date": return fmtDMY(r.admitted_date);
                default:
                    return (r[key] != null && r[key] !== "") ? r[key] : "-";
            }
        };
        const body = rows.map((r, i) => cols.map((c) => val(r, c.key, i)));
        return { header, body };
    }

    // File name from the current filter. One class -> that class name. Multiple classes
    // (e.g. a whole branch selected) -> the branch name when a single branch is picked, else
    // the classes joined. No class/branch -> a generic name.
    exportFileName(ext) {
        const primary = this.state.getClasses || [];
        const fallback = (this.props.globals && this.props.globals.globals && this.props.globals.globals.classes) || [];
        const classNameOf = (id) => {
            const c = primary.find((x) => Number(x.id) === Number(id)) || fallback.find((x) => Number(x.id) === Number(id));
            return c ? c.class : null;
        };
        const classNames = (this.state.classSearch || []).map(classNameOf).filter(Boolean);
        const branches = this.state.branches || [];
        const branchNames = (this.state.branchSearch || [])
            .map((id) => (branches.find((b) => Number(b.id) === Number(id)) || {}).branch_name)
            .filter(Boolean);

        let raw;
        if (classNames.length === 1) raw = classNames[0];
        else if (classNames.length > 1) raw = branchNames.length === 1 ? branchNames[0] : classNames.join("_");
        else if (branchNames.length === 1) raw = branchNames[0];
        else raw = "non-academic-students";

        // Strip characters that are invalid in file names.
        const base = raw.replace(/[\\/:*?"<>|]+/g, " ").replace(/\s+/g, "_").replace(/^_+|_+$/g, "") || "students";
        return `${base}.${ext}`;
    }

    handleDownloadExcel = () => {
        const { header, body } = this.buildExportMatrix();
        if (!body.length) { alert("No students to export. Select a filter to load students first."); return; }
        const aoa = [header, ...body];
        const cols = header.map((h, i) => ({ wch: Math.max(12, h.length + 2, ...body.map((r) => String(r[i] == null ? "" : r[i]).length + 2)) }));
        exportExcel([{ name: "Students", aoa, cols }], this.exportFileName("xlsx"));
    };

    // PDF via the browser print window — the same approach the Finance module uses:
    // an institute-headed HTML table that auto-triggers window.print() (save as PDF).
    handleDownloadPdf = () => {
        const { header, body } = this.buildExportMatrix();
        if (!body.length) { alert("No students to export. Select a filter to load students first."); return; }

        // Prefer the org-profile query (works for staff); fall back to cookies. Logo comes only
        // from the query since the institute_logo cookie is never set in the staff app.
        const org = this.state.orgProfile || {};
        const orgName = org.organisation_name || Cookies.get("institutename") || "";
        const orgAddress = org.complete_address || Cookies.get("institute_address") || "";
        const logoFile = org.logo || Cookies.get("institute_logo") || "";
        const logoUrl = logoFile ? `https://support.rizee.in/files/${logoFile}` : "";
        const esc = (v) => String(v == null ? "" : v).replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));

        const thead = header.map((h) => `<th>${esc(h)}</th>`).join("");
        const tbody = body.map((r) => `<tr>${r.map((c) => `<td>${esc(c)}</td>`).join("")}</tr>`).join("");

        // Browsers use the document title as the default "Save as PDF" file name → use the class name.
        const docTitle = this.exportFileName("pdf").replace(/\.pdf$/, "");

        const win = window.open("", "_blank", "width=1100,height=700");
        if (!win) { alert("Popup blocked. Please allow popups to print / save as PDF."); return; }
        win.document.write(`<html><head><title>${esc(docTitle)}</title><style>
            *{margin:0;padding:0;box-sizing:border-box}
            body{font-family:Arial,sans-serif;padding:24px;color:#111}
            .header{position:relative;text-align:center;border-bottom:2px solid #333;padding-bottom:12px;margin-bottom:16px;min-height:60px}
            .header img{position:absolute;left:0;top:0;width:auto;height:60px;object-fit:contain}
            .org-name{font-size:20px;font-weight:700;color:#111;margin-bottom:3px}
            .org-address{font-size:11px;color:#555;line-height:1.5;margin:0 auto;max-width:500px}
            .report-title{font-size:15px;font-weight:700;margin-bottom:4px}
            .report-sub{font-size:12px;color:#555;margin-bottom:16px}
            table{width:100%;border-collapse:collapse;font-size:12px}
            th{background:#f3f4f6;padding:7px 10px;text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.5px;border-bottom:2px solid #d1d5db;white-space:nowrap}
            td{padding:6px 10px;border-bottom:1px solid #f0f0f0;white-space:nowrap}
            tr:nth-child(even) td{background:#fafafa}
            @media print{body{padding:10px}}
        </style></head><body>
            <div class="header">
                ${logoUrl ? `<img src="${logoUrl}" />` : ""}
                <div>
                    <div class="org-name">${esc(orgName)}</div>
                    <div class="org-address">${esc(orgAddress)}</div>
                </div>
            </div>
            <div class="report-sub">${body.length} students &nbsp;|&nbsp; Generated ${esc(new Date().toLocaleString())}</div>
            <table>
                <thead><tr>${thead}</tr></thead>
                <tbody>${tbody}</tbody>
            </table>
            <script>
                ${logoUrl ? `var img=document.querySelector('img');if(img&&!img.complete){img.onload=function(){window.print();};img.onerror=function(){window.print()};}else{window.print();}` : `window.print();`}
            <\/script>
        </body></html>`);
        win.document.close();
    };

    handleDeleteStudent = async (row) => {
        // Checked BEFORE the confirm prompt: a role without is_delete should be told
        // they lack access, not asked to confirm a delete that can't happen.
        if (!this.guard.requireDelete()) return;

        const confirmDelete = window.confirm(
            `Are you sure you want to delete student ${row.student_name} from ${row.branch_name} - ${row.class_name} - ${row.section_name}?`
        );
        if (confirmDelete) {
            this.setState({ deletingStudentId: row.edu_student_id });
            try {
                const result = await this.props.deleteEduStudentMutation({
                    variables: {
                        edu_student_id: parseInt(row.edu_student_id) || 0,
                        student_user_id: parseInt(row.student_user_id) || 0
                    }
                });
                if (result.data?.deleteEduStudentMutation) {
                    // Drop the row from the frontend immediately (DB is now estatus=0).
                    this.setState(prev => ({
                        deletedEduStudentIds: [...prev.deletedEduStudentIds, String(row.edu_student_id)]
                    }));
                    // Sync with the server in the BACKGROUND (not awaited, no args) so the
                    // button spinner clears right away and the full-page loader never shows.
                    const q = this.props.getNewEducationalStudents;
                    if (q && q.refetch) q.refetch().catch(() => {});
                } else {
                    alert("Failed to delete student.");
                }
            } catch (err) {
                alert("Error deleting student: " + err.message);
            } finally {
                this.setState({ deletingStudentId: null });
            }
        }
    };

    // Toggle enrollment: Enrolled -> Dropout, or Dropout -> Rejoin.
    // This changes the student's status, so it's a write → is_edit (not is_delete: the
    // record survives, and a Dropout can be Rejoined). Checked before the confirm.
    handleToggleEnrollment = async (row) => {
        if (!this.guard.requireEdit()) return;

        const isEnrolled = Number(row.studentEnrollmentDropoutId ?? 1) !== 2;
        const nextStatus = isEnrolled ? 2 : 1; // 2 = dropout, 1 = rejoin
        const verb = isEnrolled ? "mark as Dropout" : "Rejoin";
        if (!row.edu_student_id) {
            alert("Enrollment status can only be changed for academic (admitted) students.");
            return;
        }
        if (!window.confirm(`Are you sure you want to ${verb} ${row.student_name}?`)) return;
        this.setState({ togglingStudentId: row.edu_student_id });
        try {
            const result = await this.props.setEduStudentEnrollmentStatus({
                variables: { edu_student_id: parseInt(row.edu_student_id) || 0, student_user_id: parseInt(row.student_user_id) || 0, status: nextStatus },
            });
            if (result.data?.setEduStudentEnrollmentStatus) {
                // Update the row's status in place so the Status/icon flip instantly,
                // without awaiting or blanking the page on a refetch. nextStatus now
                // matches the estatus convention directly (2 = Dropout, 1 = Enrolled).
                const newStatus = nextStatus;
                this.setState(prev => ({
                    statusOverrides: { ...prev.statusOverrides, [String(row.edu_student_id)]: newStatus }
                }));
                // Reconcile with the server in the BACKGROUND (not awaited, no args); once it
                // returns, drop the override so server data is the source of truth again.
                const q = this.props.getNewEducationalStudents;
                if (q && q.refetch) {
                    q.refetch()
                        .then(() => this.setState(prev => {
                            const next = { ...prev.statusOverrides };
                            delete next[String(row.edu_student_id)];
                            return { statusOverrides: next };
                        }))
                        .catch(() => {});
                }
            } else {
                alert("Failed to update enrollment status.");
            }
        } catch (err) {
            alert("Error updating status: " + err.message);
        } finally {
            this.setState({ togglingStudentId: null });
        }
    };

    // Row "edit" — checked before the edit modal opens, so a role without is_edit
    // never sees a form it isn't allowed to save. The button stays clickable.
    EditModal = (data) => {
        if (!this.guard.requireEdit()) return;

        this.setState({
            editModal: true,
            rowData: data,
            parentName: data.parent_name !== "-" ? data.parent_name : "",
            parentMobile: data.parent_mobile !== "-" ? data.parent_mobile : "",
            parentPassword: data.parent_password ?? "",
            student_id: data.edu_student_id,
            edu_student_id: data.edu_student_id,
            student_user_id: data.student_user_id,
            profile_image_base: data.profile_image_base,
        });
    };

    parentHandleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "parent_name") this.setState({ parentName: value, parentNameError: "" });
        if (name === "parent_mobile") {
            this.setState({ parentMobile: value });
            this.setState({ parentMobileError: (value.length !== 10) ? "Mobile number must be 10 digits" : "" });
        }
        if (name === "parent_password") this.setState({ parentPassword: value, parentPasswordError: "" });
    };

    handleFormSubmit = async () => {
        // Checked before the field validation so a role without is_edit is told they
        // lack access, rather than being sent to fix a form they can't submit.
        if (!this.guard.requireEdit()) return;

        if (!this.state.parentName) return this.setState({ parentNameError: "Please enter name" });
        if (this.state.parentMobile.length !== 10) return this.setState({ parentMobileError: "Please check mobile number" });
        if (!this.state.parentPassword) return this.setState({ parentPasswordError: "Please enter password" });

        this.setState({ isSubmitting: true });
        const params = {
            student_id: parseInt(this.state.student_id),
            parent_mobile: this.state.parentMobile.toString(),
            parent_name: this.state.parentName,
            parent_password: this.state.parentPassword,
        };
        this.editParent(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message) });
        });
    };

    // The four mutation methods below are handed to EditDetailsModal as callbacks
    // (onSave / onEditEduStudent / onSaveStudentName / onAddProfileImage), so they are
    // the last gate before each write leaves the client. Guarded individually rather
    // than trusting the modal to have been opened through a checked path.
    editParent = async (params) => {
        if (!this.guard.requireEdit()) return;

        const result = await this.props.editParent({ variables: { params } });
        if (result.data?.editParent) {
            // No args: re-run with the query's declared variables. Passing an undeclared
            // variable (institute_id) makes the react-apollo HOC loop reconciling it.
            await this.props.getNewEducationalStudents?.refetch?.();
            return result.data;
        }
    };

    resetFilters = () => {
        const { branches } = this.state;
        const allBranchIds = branches.map(b => b.id);
        const allClassIds = Array.from(new Set(branches.flatMap(b => b.sections || []).map(s => s.class_id)));
        const allStreamIds = Array.from(new Set(branches.flatMap(b => b.sections || []).map(s => s.stream_id).filter(Boolean)));
        const allSectionIds = branches.flatMap(b => b.sections || []).map(s => s.id);
        this.setState({ branchSearch: allBranchIds, classSearch: allClassIds, streamSearch: allStreamIds, sectionSearch: allSectionIds, enrollmentSearch: [0, 1, 2] });
    };

    editEduStudent = async (params) => {
        if (!this.guard.requireEdit()) return;

        const result = await this.props.editEduStudentMutation({ variables: { params } });
        if (result.data?.editEduStudent) {
            // No args: re-run with the query's declared variables. Passing an undeclared
            // variable (institute_id) makes the react-apollo HOC loop reconciling it.
            await this.props.getNewEducationalStudents?.refetch?.();
            this.setState(prev => ({
                rowData: {
                    ...prev.rowData,
                    student_name: params.student_name,
                    branch: params.branch_id,
                    class: params.class_id,
                    stream: params.stream_id,
                    section: params.section_id,
                }
            }));
        }
        return result.data;
    };

    editStudentName = async (student_name) => {
        if (!this.guard.requireEdit()) return;

        const row = this.state.rowData;
        const params = {
            id: parseInt(row.student_user_id),
            student_name,
            contact_no: row.contact_no || "",
            section_id: parseInt(row.section) || 0,
            class_id: parseInt(row.class) || 0,
            exam_id: parseInt(row.exam_id) || 0,
            branch_id: parseInt(row.branch) || 0,
            username: Cookies.get("username") || "",
        };
        const result = await this.props.editStudent({ variables: { params } });
        if (result.data?.editStudent) {
            // No args: re-run with the query's declared variables. Passing an undeclared
            // variable (institute_id) makes the react-apollo HOC loop reconciling it.
            await this.props.getNewEducationalStudents?.refetch?.();
            this.setState(prev => ({
                rowData: { ...prev.rowData, student_name }
            }));
        }
        return result.data;
    };

    // Uploading a profile image is a write → is_edit.
    addProfileImage = async (params) => {
        if (!this.guard.requireEdit()) return;

        const result = await this.props.addProfileImageMutation({ variables: params });
        if (result.data?.addProfileImage) {
            // No args: re-run with the query's declared variables. Passing an undeclared
            // variable (institute_id) makes the react-apollo HOC loop reconciling it.
            await this.props.getNewEducationalStudents?.refetch?.();
        }
        return result.data;
    };

    // "Add Student" — opens StudentModal, which owns the create mutation. Gating the
    // opener is what stops the create; the button itself stays visible and clickable.
    openAddStudentModal = () => {
        if (!this.guard.requireEdit()) return;
        this.setState({ modalShow: true });
    };

    render() {
        // is_view === 0 → the student data is never rendered, and the read query is
        // skipped so nothing is fetched. This MUST stay above the prop reads below:
        // with the query skipped, getNewEducationalStudents is undefined and the lines
        // that follow would throw. The page shell comes from EducationManagementStudents.jsx,
        // so the user can still navigate to modules they DO have.
        // (FIN, the style block, is declared further down inside render, so this early
        // return carries its own inline wrapper rather than referencing it.)
        if (!this.guard.canView()) {
            return (
                <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px" }}>
                    <AccessDeniedCard />
                </div>
            );
        }

        const getNewEducationalStudents = this.props.getNewEducationalStudents;
        console.log("getNewEducationalStudents", getNewEducationalStudents.data);

        // Only show the full-page shimmer on the FIRST load (no data yet). Background
        // refetches after a rejoin/dropout/delete keep the previous data present, so they
        // must NOT blank the page — otherwise it looks like continuous loading.
        if (getNewEducationalStudents.loading && !getNewEducationalStudents.getNewEducationalStudents) return <PageCardShimmer filters={4} />;
        if (getNewEducationalStudents.error) { alert("Server Error. " + getNewEducationalStudents.error.message); return null; }

        const { branches, getClasses, streams, branchSearch, classSearch, streamSearch, sectionSearch, enrollmentSearch } = this.state;

        // ── Dropdown options — derived from GET_BRANCHES / GET_CLASSES ────────

        const selectedBranchObjs = branchSearch.length > 0
            ? branches.filter(b => branchSearch.map(Number).includes(Number(b.id)))
            : branches;

        // Iterate getClasses (already sorted by order_no from getExamClasses)
        // filtered to the selected branches' classes, so options follow order_no.
        const branchClassIds = new Set(
            selectedBranchObjs.flatMap(b => b.sections || []).map(s => String(s.class_id))
        );
        const classOptions = getClasses
            .filter(c => branchClassIds.has(String(c.id)))
            .map(c => ({ value: c.id, label: c.class }));

        // Streams available for the selected branches+classes, derived from sections' stream_id
        const streamOptions = Array.from(new Set(
            selectedBranchObjs
                .flatMap(b => b.sections || [])
                .filter(s => classSearch.length === 0 || classSearch.map(Number).includes(Number(s.class_id)))
                .map(s => s.stream_id)
                .filter(Boolean)
        ))
            .map(sid => (streams || []).find(st => Number(st.id) === Number(sid)))
            .filter(Boolean)
            .map(st => ({ value: st.id, label: st.stream }));

        const sectionOptions = selectedBranchObjs
            .flatMap(b => b.sections || [])
            .filter(s => classSearch.length === 0 || classSearch.map(Number).includes(Number(s.class_id)))
            // Non-stream sections (stream_id null) always shown; stream sections only if their stream is selected
            .filter(s => !s.stream_id || streamSearch.map(Number).includes(Number(s.stream_id)))
            .map(s => ({ value: s.id, label: s.section_name }));

        // ── Filter student data ───────────────────────────────────────────────
        // The data unions academic rows (education_mngt) with non-academic rows
        // (neetjee student_users). Their class/stream/section ids live in DIFFERENT
        // tables, but the filter OPTIONS are built only from academic sections. So
        // the class/stream/section filters govern ONLY academic ids — a row whose
        // id isn't in the academic universe (non-academic, or null) isn't dropped
        // by that filter. Branch + Enrollment apply to every row.
        const academicClassIds = new Set(branches.flatMap(b => b.sections || []).map(s => Number(s.class_id)));
        const academicStreamIds = new Set(branches.flatMap(b => b.sections || []).map(s => Number(s.stream_id)).filter(Boolean));
        const academicSectionIds = new Set(branches.flatMap(b => b.sections || []).map(s => Number(s.id)));

        let StudentsFilterData = getNewEducationalStudents.getNewEducationalStudents || [];

        // Hide rows deleted this session immediately (optimistic), before refetch resolves.
        if (this.state.deletedEduStudentIds.length > 0) {
            const removed = new Set(this.state.deletedEduStudentIds);
            StudentsFilterData = StudentsFilterData.filter(a => !removed.has(String(a.edu_student_id)));
        }

        // Apply optimistic status changes (dropout/rejoin) so the row's status/icon flip
        // instantly — before the background refetch confirms — without a page reload.
        const statusOverrides = this.state.statusOverrides;
        if (Object.keys(statusOverrides).length > 0) {
            StudentsFilterData = StudentsFilterData.map(a => {
                const ov = statusOverrides[String(a.edu_student_id)];
                return ov !== undefined ? { ...a, studentEnrollmentDropoutId: ov } : a;
            });
        }

        if (branchSearch.length > 0)
            StudentsFilterData = StudentsFilterData.filter(a => branchSearch.map(Number).includes(Number(a.branch_id)));

        // Class: only narrows rows whose class_id is a known academic class.
        StudentsFilterData = StudentsFilterData.filter(a => {
            const cid = Number(a.class_id);
            if (!a.class_id || !academicClassIds.has(cid)) return true;
            return classSearch.map(Number).includes(cid);
        });

        // Stream: rows without a stream (non-stream classes / non-academic) always pass.
        StudentsFilterData = StudentsFilterData.filter(a => {
            const sid = Number(a.stream_id);
            if (!a.stream_id || !academicStreamIds.has(sid)) return true;
            return streamSearch.map(Number).includes(sid);
        });

        // Section: only narrows rows whose section_id is a known academic section.
        StudentsFilterData = StudentsFilterData.filter(a => {
            const secId = Number(a.section_id);
            if (!a.section_id || !academicSectionIds.has(secId)) return true;
            return sectionSearch.map(Number).includes(secId);
        });

        // Status is derived from TWO backend fields:
        //   estatus                     — record status; 0 = soft-Deleted (set by the Delete action).
        //   studentEnrollmentDropoutId  — enrollment status; 2 = Dropout, 1/0/null = Active.
        // Deletion wins over enrollment status. studentEnrollmentDropoutId === 0 is NOT
        // "deleted" (those are active students with no dropout record) — only estatus === 0 is.
        // Normalised to a single code: 0 = Deleted, 1 = Active, 2 = Dropout.
        const statusOf = (a) => {
            const est = (a.estatus === undefined || a.estatus === null) ? null : Number(a.estatus);
            if (est === 0) return 0; // Deleted
            return Number(a.studentEnrollmentDropoutId) === 2 ? 2 : 1; // Dropout : Active
        };
        StudentsFilterData = StudentsFilterData.filter(a => [0, 1, 2].includes(statusOf(a)));

        // Enrolled / Dropout counts from the branch/class/section-filtered set, computed
        // BEFORE the enrollment filter is applied so the quick-filter buttons always show
        // the full totals for the current selection. allCount now equals the on-screen Total.
        const enrolledCount = StudentsFilterData.filter(a => statusOf(a) === 1).length;
        const dropoutCount = StudentsFilterData.filter(a => statusOf(a) === 2).length;
        const deleteCount = StudentsFilterData.filter(a => statusOf(a) === 0).length;
        const allCount = enrolledCount + dropoutCount + deleteCount;

        if (enrollmentSearch.length > 0) {
            StudentsFilterData = StudentsFilterData.filter(a => enrollmentSearch.map(Number).includes(statusOf(a)));
        }

        // Capture the currently-filtered, table-shaped rows so the Excel/PDF handlers export
        // exactly what's on screen (same filters applied).
        this._exportRows = this.tableData(StudentsFilterData);

        const labelStyle = { display: "block", fontSize: 11, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: "0.7px", marginBottom: 6 };

        const FIN = {
            wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
            card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
            cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
            iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
            titleText: { display: "flex", flexDirection: "column", textAlign: "left" },
            title: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
            subtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
            countChip: { background: "#f5f3ff", color: "#7c3aed", borderRadius: 20, padding: "4px 12px", fontWeight: 600, fontSize: 12, border: "1px solid #ddd6fe" },
            headerActions: { display: "flex", gap: 10, marginLeft: "auto", alignItems: "center", flexWrap: "wrap" },
            btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
            // Match the Finance module's toolbar buttons: green-gradient Excel, indigo Print/PDF.
            btnExcel: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, background: "linear-gradient(135deg,#16a34a,#15803d)", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 700, cursor: "pointer", height: 42 },
            btnPdf: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, background: "linear-gradient(135deg,#6366f1,#8b5cf6)", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 700, cursor: "pointer", height: 42 },
            filterBar: { padding: "16px 24px", borderBottom: "1px solid #f3f4f6" },
            content: { padding: "20px 24px" },
        };

        return (
            <div style={FIN.wrapper}>
                <Container fluid className="px-0">
                    <div style={FIN.card}>

                        {/* Header */}
                        <div style={FIN.cardHeader}>
                            <div style={FIN.iconWrapper}><i className="fal fa-user-graduate" /></div>
                            <div style={FIN.titleText}>
                                <h5 style={FIN.title}>Students</h5>
                                <span style={FIN.subtitle}>Manage institute students &amp; parent details</span>
                            </div>
                            <div style={FIN.headerActions}>
                                <button style={FIN.btnPdf} onClick={this.handleDownloadPdf} title="Print / save the filtered list as PDF">
                                    <i className="fal fa-print" /> Print / PDF
                                </button>
                                <button style={FIN.btnExcel} onClick={this.handleDownloadExcel} title="Download the filtered list as Excel">
                                    <i className="fal fa-file-excel" /> Download Excel
                                </button>
                                <button style={FIN.btnPrimary} onClick={this.openAddStudentModal}>
                                    <i className="fas fa-plus" /> Add Student
                                </button>
                            </div>
                        </div>

                        {/* Filter bar */}
                        <div style={FIN.filterBar}>
                            <Row className="g-2">
                                {/* No Branch filter — the header's branch selection scopes this list. */}

                                <Col lg md={4} sm={12} className="mb-2 mb-lg-0">
                                    <label style={labelStyle}>Class</label>
                                    <CheckboxDropdown
                                        options={classOptions}
                                        value={classSearch}
                                        onChange={(val) => {
                                            if (val.length === 0) {
                                                this.setState({ classSearch: [], streamSearch: [], sectionSearch: [] });
                                                return;
                                            }
                                            const selSections = selectedBranchObjs
                                                .flatMap(b => b.sections || [])
                                                .filter(s => val.map(Number).includes(Number(s.class_id)));
                                            const newStreamIds = Array.from(new Set(selSections.map(s => s.stream_id).filter(Boolean)));
                                            const newSectionIds = selSections.map(s => s.id);
                                            this.setState({ classSearch: val, streamSearch: newStreamIds, sectionSearch: newSectionIds });
                                        }}
                                        placeholder="All Classes"
                                    />
                                </Col>

                                {streamOptions.length > 0 && (
                                    <Col lg md={4} sm={12} className="mb-2 mb-lg-0">
                                        <label style={labelStyle}>Stream</label>
                                        <CheckboxDropdown
                                            options={streamOptions}
                                            value={streamSearch.filter(sid => streamOptions.some(o => Number(o.value) === Number(sid)))}
                                            onChange={(val) => {
                                                // Sections for selected classes that match the chosen streams (plus non-stream sections)
                                                const newSectionIds = selectedBranchObjs
                                                    .flatMap(b => b.sections || [])
                                                    .filter(s => classSearch.length === 0 || classSearch.map(Number).includes(Number(s.class_id)))
                                                    .filter(s => !s.stream_id || val.map(Number).includes(Number(s.stream_id)))
                                                    .map(s => s.id);
                                                this.setState({ streamSearch: val, sectionSearch: newSectionIds });
                                            }}
                                            placeholder="All Streams"
                                        />
                                    </Col>
                                )}

                                <Col lg md={4} sm={12} className="mb-2 mb-lg-0">
                                    <label style={labelStyle}>Section</label>
                                    <CheckboxDropdown
                                        options={sectionOptions}
                                        value={sectionSearch}
                                        onChange={(val) => this.setState({ sectionSearch: val })}
                                        placeholder="All Sections"
                                    />
                                </Col>
                            </Row>
                            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
                                <button
                                    onClick={this.resetFilters}
                                    style={{ background: "none", border: "1.5px solid #7C3AED", color: "#7C3AED", borderRadius: 7, padding: "5px 16px", fontSize: 12.5, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}
                                >
                                    <i className="fas fa-undo" style={{ fontSize: 11 }}></i> Reset Filters
                                </button>
                            </div>
                        </div>

                        {/* Table */}
                        <div style={FIN.content}>
                            {branches.length === 0 || (branchSearch.length === 0 && classSearch.length === 0 && sectionSearch.length === 0) ? (
                                <div style={{ textAlign: "center", padding: "48px 0", color: "#9CA3AF" }}>
                                    <i className="fas fa-filter" style={{ fontSize: "2rem", marginBottom: 12, display: "block" }}></i>
                                    Please select a filter to view students
                                </div>
                            ) : (
                                <CardLessDataTable
                                    parentData={this.tableData(StudentsFilterData)}
                                    particlecolumns={this.articlecolumns}
                                    tableHeading={{ Title: "Students" }}
                                    search={true}
                                    name="hostel_attendance"
                                    // Students count + quick status filters, shown on the right side
                                    // of the search row (leftContent renders with margin-left:auto).
                                    leftContent={(() => {
                                        const isAll = enrollmentSearch.length !== 1;
                                        const isEnrolled = enrollmentSearch.length === 1 && Number(enrollmentSearch[0]) === 1;
                                        const isDropout = enrollmentSearch.length === 1 && Number(enrollmentSearch[0]) === 2;
                                        const isDelete = enrollmentSearch.length === 1 && Number(enrollmentSearch[0]) === 0;
                                        const pill = (active, activeColor) => ({
                                            display: "inline-flex", alignItems: "center", gap: 7, borderRadius: 8, padding: "6px 14px",
                                            fontSize: 12.5, fontWeight: 600, cursor: "pointer",
                                            border: `1.5px solid ${active ? activeColor : "#E5E7EB"}`,
                                            background: active ? activeColor : "#fff",
                                            color: active ? "#fff" : "#374151",
                                        });
                                        const badge = (active) => ({
                                            fontSize: 11, fontWeight: 700, borderRadius: 20, padding: "1px 8px",
                                            background: active ? "rgba(255,255,255,0.25)" : "#F3F4F6",
                                            color: active ? "#fff" : "#111827",
                                        });
                                        return (
                                            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                                                <button onClick={() => this.setState({ enrollmentSearch: [0, 1, 2] })} style={pill(isAll, "#7C3AED")}>
                                                    All <span style={badge(isAll)}>{allCount}</span>
                                                </button>
                                                <button onClick={() => this.setState({ enrollmentSearch: [1] })} style={pill(isEnrolled, "#10B981")}>
                                                    Active <span style={badge(isEnrolled)}>{enrolledCount}</span>
                                                </button>
                                                <button onClick={() => this.setState({ enrollmentSearch: [2] })} style={pill(isDropout, "#EF4444")}>
                                                    Dropout <span style={badge(isDropout)}>{dropoutCount}</span>
                                                </button>
                                                <button onClick={() => this.setState({ enrollmentSearch: [0] })} style={pill(isDelete, "#6B7280")}>
                                                    Deleted <span style={badge(isDelete)}>{deleteCount}</span>
                                                </button>
                                            </div>
                                        );
                                    })()}
                                />
                            )}
                        </div>
                    </div>
                </Container>

                {/* ── Modals ───────────────────────────────────────────────── */}
                <StudentModal
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false })}
                    onSuccess={() => {
                        if (this.props.getNewEducationalStudents && this.props.getNewEducationalStudents.refetch) {
                            // No args: re-run with the declared variables (see refetch note above).
                            this.props.getNewEducationalStudents.refetch();
                        }
                    }}
                />

                <EditDetailsModal
                    show={this.state.editModal}
                    onHide={() => this.setState({
                        editModal: false,
                        rowData: [],
                        parentName: "", parentNameError: "",
                        parentMobile: "", parentMobileError: "",
                        parentPassword: "", parentPasswordError: "",
                        submitError: "",
                        edu_student_id: 0,
                        student_user_id: 0,
                        isSubmitting: false, currentStep: 1,
                    })}
                    stateData={this.state}
                    streams={this.state.streams}
                    onSave={this.editParent}
                    onSaveStudentName={this.editStudentName}
                    onEditEduStudent={this.editEduStudent}
                    onAddProfileImage={this.addProfileImage}
                />

                {/* Shown instead of creating / editing / deleting when the grant is
                    missing. One modal serves every intercepted action. */}
                <AccessDeniedModal
                    show={this.state.accessDeniedShow}
                    onHide={this.guard.hideAccessDenied}
                />
            </div>
        );
    }
}

// skip on the READ queries: is_view === 0 → the module's data is not fetched at all,
// so it can't sit in the Apollo cache behind the Access Denied card. The mutations
// carry no skip — skipping a mutation HOC removes the prop function entirely and the
// guarded handlers would throw "this.props.X is not a function".
const skipUnlessViewable = () => !canView(NON_ACADEMIC_STUDENTS_MODULE, NON_ACADEMIC_STUDENTS_SUB);

export default withRouter(withApollo(compose(
    graphql(GET_STUDENT_DETAILS, {
        options: () => ({ variables: { institution_id: parseInt(Cookies.get("institutionid")), branch_id: Cookies.get("branch_id").toString(""), include_inactive: true } }),
        skip: skipUnlessViewable,
        name: "getNewEducationalStudents",
    }),
    graphql(EDIT_PARENT, {
        name: "editParent",
    }),
    graphql(EDIT_STUDENT, {
        name: "editStudent",
    }),
    graphql(EDIT_EDU_STUDENT, {
        name: "editEduStudentMutation",
    }),
    graphql(ADD_PROFILE_IMAGE, {
        name: "addProfileImageMutation",
    }),
    graphql(DELETE_STUDENT, {
        name: "deleteEduStudentMutation",
    }),
    graphql(SET_ENROLLMENT_STATUS, {
        name: "setEduStudentEnrollmentStatus",
    })
)(EducationManagementStudentsSection)));
